module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921084149_T.a6a46abb.jpg";